
<script lang="ts">
import { useIntersectionObserver } from "@vueuse/core";
import { ref, nextTick } from "vue";
function onIdle(cb = () => {}) {
  const replicateWindow: any = window;
  if ("requestIdleCallback" in window) {
    replicateWindow.requestIdleCallback(cb);
  } else {
    setTimeout(() => {
      nextTick(cb);
    }, 500);
  }
}
export default {
  props: {
    renderOnIdle: Boolean,
    setMinHeight: Boolean,
    unrender: Boolean,
    minHeight: Number,
    unrenderDelay: {
      type: Number,
      default: 10000,
    },
  },
  setup(props: any) {
    const shouldRender = ref(false);
    const targetEl = ref();
    const fixedMinHeight = ref(0);
    let unrenderTimer: any;
    let renderTimer: any;
    const { stop } = useIntersectionObserver(
      targetEl,
      ([{ isIntersecting }]) => {
        if (isIntersecting) {
          // perhaps the user re-scrolled to a component that was set to unrender. In that case stop the unrendering timer
          clearTimeout(unrenderTimer);
          // if we're dealing underndering lets add a waiting period of 200ms before rendering. If a component enters the viewport and also leaves it within 200ms it will not render at all. This saves work and improves performance when user scrolls very fast
          renderTimer = setTimeout(
            () => (shouldRender.value = true),
            props.unrender ? 200 : 0
          );
          shouldRender.value = true;
          if (!props.unrender) {
            stop();
          }
        } else if (props.unrender) {
          // if the component was set to render, cancel that
          const margin =
            15 +
            0.75 *
              parseFloat(getComputedStyle(document.documentElement).fontSize);
          clearTimeout(renderTimer);
          unrenderTimer = setTimeout(() => {
            if (targetEl.value) {
              fixedMinHeight.value = targetEl.value.clientHeight;
              shouldRender.value = false;
            }
          }, props.unrenderDelay);
        }
      },
      {
        rootMargin: "50%",
      }
    );
    if (props.renderOnIdle) {
      onIdle(() => {
        shouldRender.value = true;
        if (!props.unrender) {
          stop();
        }
      });
    }
    return { targetEl, shouldRender, fixedMinHeight };
  },
};
</script>
<template>
  <div
    v-if="setMinHeight"
    :style="`min-height:${
      fixedMinHeight ? fixedMinHeight : minHeight ?? 164
    }px`"
    ref="targetEl"
  >
    <slot v-if="shouldRender" />
  </div>

  <div v-else>
    <slot />
  </div>
</template>